import React from "react";

const Footer: React.FC = () => {
  return <footer className="text-center py-6 font-medium">To-do list</footer>;
};

export default Footer;
